export default __webpack_public_path__ + "static/media/Skirt of the Dragon King.881ca2d7.jpg";